<template>
  <div class="app-container">
    <el-form @load="loading" ref="form" :model="form" label-width="80px">
      <el-form-item label="视频标题" required>
        <el-input v-model="form.liveTitle"/>
      </el-form-item>
      <el-form-item label="视频描述">
        <el-input v-model="form.liveDescription" type="textarea"/>
      </el-form-item>
      <div style="overflow:auto;height: 60vh;">
        <el-form-item label="收费规则">
          <el-radio-group v-model="form.payStatus">
            <el-radio v-for="item in payOptions" :label="item.value">{{ item.name }}</el-radio>
          </el-radio-group>
          <el-input-number size="small" style="margin-left: 20px;" v-model="form.price"
                           v-if="form.payStatus === 1"></el-input-number>
        </el-form-item>
        <el-form-item label="直播科属">
          <el-select v-model="form.categoryId" style="width: 100%">
            <el-option v-for="item in categoryOptions" :key="item.forumCategoryId"
                       :label="item.categoryName" :value="item.forumCategoryId"></el-option>
          </el-select>
        </el-form-item>
        <el-form-item v-if="userOptions.length > 0" label="所属领域">
          <el-select v-model="form.userDataType" style="width: 100%">
            <el-option v-for="item in userOptions" :key="item.value" :label="item.name"
                       :value="item.value">
            </el-option>
          </el-select>
        </el-form-item>
        <el-form-item label="视频标签">
          <el-select v-model="form.liveVideoTabId" style="width: 100%" filterable @change="">
            <el-option v-for="item in tabOptions" :key="item.liveVideoTabId"
                       :label="item.liveVideoTabTitle" :value="item.liveVideoTabId">
            </el-option>
          </el-select>
        </el-form-item>
        <el-form-item label="上传封面">
          <el-upload ref="uploadCoverRef" accept=".png,.jpg" action="" class="upload-demo" :limit="1"
                     :on-change="change2DisplayLocalImage" :auto-upload="false">
            <div style="text-align: left;">
              <el-image style="width: 100px; height: 100px"
                        :src="uploadCoverFile !== null ? uploadCoverFileURL : getImageUrl(form.liveCover)"
                        fit="scale-down">
                <template #error>
                  <p></p>
                </template>
              </el-image>
              <br/>
              <el-button size="small" type="primary">点击上传</el-button>
            </div>

            <div slot="tip" class="el-upload__tip">
              只能上传jpg/png文件
            </div>
          </el-upload>
        </el-form-item>

        <div style="width: 40%">
          <el-form-item label="视频">
            <tx-video-player style="height: 40vh" :video-url="getImageUrl(form.pushFlowUrl)"></tx-video-player>
          </el-form-item>
        </div>


      </div>

    </el-form>
    <div slot="footer" class="dialog-footer">
      <el-button type="primary" size="small" @click="() => submitEdit()">
        保存
      </el-button>
    </div>
  </div>

</template>

<script>
import {getCategoryList, getTagList, updateVideoInfo, getVideoDetail} from "@/api/mai/liveReviews/liveReviews";
import {isVaild} from "@/utils/validate";
import {getUserType} from "@/utils/userutil";
import {getCloudUrl, getLocalFileURL} from "@/utils/urlutil";
import {getOSSUploadInfo} from "@/api/system/CSDocument/file";
import {uploadFile2OSS} from "@/utils/OSSUpload";
import {deepClone} from "@/utils";
import {handleRes} from "@/utils/handleRes";
import TxVideoPlayer from "@/components/TXVideoPlayer/txVideoPlayer";

export default {
  name: "reviewDetail",
  components: {TxVideoPlayer},
  props: {
    liveID: {
      Number
    }
  },
  async created() {
    await this.getAllTag();
    await this.getCategoryOptions()
    this.userOptions = getUserType()
    await this.getVideoDetail()
  },
  data() {
    return {
      loading: false,
      form: {},
      payOptions: [
        {
          name: "免费",
          value: 0
        },
        {
          name: "付费",
          value: 1
        }
      ],
      categoryOptions: [],
      userOptions: [],
      tabOptions: [],
      uploadCoverFile: null,
      uploadCoverFileURL: "",
    }
  },
  methods: {
    async getVideoDetail() {
      this.loading = true
      let res = await getVideoDetail({
        liveId: this.liveID
      })
      handleRes(res, () => {
        this.form = deepClone(res.data)
        for (let i = 0; i < this.tabOptions.length; i++) {
          let item = this.tabOptions[i]
          if (item.liveVideoTabTitle === this.form.liveVideoTabTitle) {
            this.form.liveVideoTabId = item.liveVideoTabId
            break
          }
        }
      })
      this.utils.stopLoading(this)
    },
    async getAllTag() {
      let res = await getTagList({
        pageSize: 0
      })
      this.tabOptions = res.data.rows
    },
    async getCategoryOptions() {
      let res = await getCategoryList()
      if (isVaild(res)) {
        this.categoryOptions = res.data
      }

    },
    change2DisplayLocalImage(uploadFile) {
      this.$refs.uploadCoverRef.clearFiles();
      this.uploadCoverFile = uploadFile;
      this.uploadCoverFileURL = getLocalFileURL(uploadFile);
    },
    getImageUrl(path) {
      return getCloudUrl(path)
    },
    async submitEdit() {
      let savepathParamsRes = await getOSSUploadInfo({
        DataType: "10",
        ID: "0",
      });
      if (!isVaild(savepathParamsRes)) {
        return;
      }
      let savePathParams = savepathParamsRes.resultData
      //上传封面
      if (isVaild(this.uploadCoverFile)) {
        // printObj(this.uploadCoverFile.raw)
        let timestamp = new Date().valueOf();

        let uploadRes;
        let fileName;
        if (isVaild(this.uploadCoverFile)) {
          fileName = savePathParams.PicSavePath + timestamp + this.uploadCoverFile.name.substring(this.uploadCoverFile.name.lastIndexOf("."));
          // console.log("upload info " + savePathParams.PicSavePath + " " + fileName)
          uploadRes = await uploadFile2OSS(savePathParams, new Blob([this.uploadCoverFile.raw], {
            type: this.uploadCoverFile.raw.type
          }), fileName)
        }
        if (uploadRes.status === 0) {
          this.form.liveCover = this.config.RESOURCES + "/" + fileName
          // console.log(this.form.liveCover)
        } else {
          this.$message({
            type: "error",
            message: "上传失败"
          })
        }
        this.$refs.uploadCoverRef.clearFiles();
      }
      let data = deepClone(this.form)

      //更新
      updateVideoInfo(data).then((res) => {
        handleRes(res, () => {
          this.$message({
            type: "success",
            message: "编辑成功",
          });
          this.getVideoDetail()
        })
      })
    }
  }
}
</script>

<style scoped>

</style>